import React, { useState, useEffect } from "react";
import { getAvatarStyle } from "../utils/avatarColors";

const getInitials = (name) => {
  if (!name) return "??";
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);
};

/**
 * Profile picture with graceful fallback: renders the image when it loads,
 * otherwise the person's initials on a deterministic colored gradient.
 *
 * `className` and `style` apply to both the <img> and the fallback so callers
 * keep their sizing/border/shape styling. `textClassName` sizes the initials.
 */
export default function UserAvatar({
  src,
  name,
  className = "",
  style,
  textClassName = "",
}) {
  const [errored, setErrored] = useState(false);

  // A new src gets a fresh chance to load.
  useEffect(() => {
    setErrored(false);
  }, [src]);

  if (!src || errored) {
    return (
      <div
        className={`flex items-center justify-center text-white font-semibold select-none ${textClassName} ${className}`}
        style={{ ...getAvatarStyle(name), ...style }}
        aria-label={name || undefined}
      >
        {getInitials(name)}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name || ""}
      className={className}
      style={style}
      onError={() => setErrored(true)}
    />
  );
}
